$(document).ready(function() {
  $('.product_media').each(function() {
    var $element = $(this);

    // Clean the data-title
    var title = $element.data('title');
    if (title) {
      var newTitle = title.replace(/'/g, '');
      $element.attr('data-title', newTitle);
    }

    // Preload the high-res image
    var url = $element.data('img-url');
    if (url) {
      $('<link>', {
        rel: 'preload',
        href: url,
        as: 'image'
      }).appendTo('head');
    }
  });

  setTimeout(function() {
    calculateThumbWidth();
    scrollGalleryTo(0);
  
    const $firstVisible = $('.product_media:visible').first();
    const newSrc = $firstVisible.data('img-url');
  
    if (newSrc) {
      const img = new Image();
      img.onload = function () {
        $('.product_featured_media').attr('src', newSrc);
        $('.atc_fixed_content img').attr('src', $firstVisible.data('img-url-thumb'));
      };
      img.src = newSrc;
    }
  }, 50)

  // Swap featured image after preload completes
  $(document).on('click', '.product_media', function() {
    var newSrc = $(this).data('img-url');
    var img = new Image();
    img.onload = function() {
      $('.product_featured_media').attr('src', newSrc);
    };
    img.src = newSrc;
  });
  
  let currentOffset = 0;
  let thumbWidth = 0;
  const visibleCount = 7;
  const gap = 10;

  function calculateThumbWidth() {
    const $firstThumb = $('.product_media:visible').first();
    if ($firstThumb.length) {
      const style = window.getComputedStyle($firstThumb[0]);
      const width = $firstThumb[0].getBoundingClientRect().width;
      const marginLeft = parseFloat(style.marginLeft || 0);
      const marginRight = parseFloat(style.marginRight || 0);
      thumbWidth = Math.ceil(width + marginLeft + marginRight);
    }
  }

  function scrollGalleryTo(offset) {
    const $grid = $('.product_thumbnail_grid');
    const visibleThumbs = $grid.children('.product_media:visible');
    const maxOffset = visibleThumbs.length - visibleCount;
    currentOffset = Math.max(0, Math.min(offset, maxOffset));
    $grid.css('transform', `translateX(-${(thumbWidth + gap) * currentOffset}px)`);
  }

//  calculateThumbWidth();

  $(window).on('resize', function() {
    calculateThumbWidth();
    scrollGalleryTo(currentOffset);
  });

  $(document).on('click', '.product_media', function () {
  var visibleThumbs = $('.product_media:visible');
  var index = visibleThumbs.index(this);
    const $grid = $('.product_thumbnail_grid');

    const start = currentOffset;
    const end = currentOffset + visibleCount - 1;

  if (index >= end - 2 && index < visibleThumbs.length - 1) {
      scrollGalleryTo(currentOffset + 1);
    } else if (index <= start + 2 && currentOffset > 0) {
      scrollGalleryTo(currentOffset - 1);
    }

    const newSrc = $(this).data('img-url');
    if (newSrc) {
      const img = new Image();
      img.onload = function () {
        $('.product_featured_media').attr('src', newSrc);
      };
      img.src = newSrc;
    }
  });
  let touchStartX = 0;
  let touchEndX = 0;
  
  $('.product_thumbnail_grid_wrapper').on('touchstart', function(e) {
    touchStartX = e.originalEvent.touches[0].clientX;
  });
  
  $('.product_thumbnail_grid_wrapper').on('touchend', function(e) {
    touchEndX = e.originalEvent.changedTouches[0].clientX;
    handleSwipe();
  });
  
  function handleSwipe() {
    const swipeDistance = touchEndX - touchStartX;
  
    if (Math.abs(swipeDistance) < 30) return; // ignore tiny movements
  
    if (swipeDistance < 0) {
      // swipe left → advance right
      scrollGalleryTo(currentOffset + 1);
    } else {
      // swipe right → move left
      scrollGalleryTo(currentOffset - 1);
    }
  }

  let mainTouchStartX = 0;
  let mainTouchEndX = 0;
  
  $('.product_featured_media').on('touchstart', function(e) {
    mainTouchStartX = e.originalEvent.touches[0].clientX;
  });
  
  $('.product_featured_media').on('touchend', function(e) {
    mainTouchEndX = e.originalEvent.changedTouches[0].clientX;
    handleMainImageSwipe();
  });
  
  function handleMainImageSwipe() {
    const swipeDistance = mainTouchEndX - mainTouchStartX;
  
    if (Math.abs(swipeDistance) < 30) return;
  
const $thumbs = $('.product_media:visible');
    let currentIndex = -1;
    const currentSrc = $('.product_featured_media').attr('src');
  
    $thumbs.each(function(index) {
      if ($(this).data('img-url') === currentSrc) {
        currentIndex = index;
      }
    });
  
    if (currentIndex === -1) return; // couldn't find match
  
    let newIndex = currentIndex;
  
    if (swipeDistance < 0 && currentIndex < $thumbs.length - 1) {
      newIndex = currentIndex + 1;
    } else if (swipeDistance > 0 && currentIndex > 0) {
      newIndex = currentIndex - 1;
    }
  
    if (newIndex !== currentIndex) {
      const $newThumb = $thumbs.eq(newIndex);
      const newSrc = $newThumb.data('img-url');
  
      if (newSrc) {
        const img = new Image();
        img.onload = function () {
          $('.product_featured_media').attr('src', newSrc);
        };
        img.src = newSrc;
      }
  
      // auto-scroll thumbnail slider if needed
      const start = currentOffset;
      const end = currentOffset + visibleCount - 1;
  
      if (newIndex >= end - 2 && newIndex < $thumbs.length - 1) {
        scrollGalleryTo(currentOffset + 1);
      } else if (newIndex <= start + 2 && currentOffset > 0) {
        scrollGalleryTo(currentOffset - 1);
      }
    }
  }
  $(document).on('click', '.swatch-element', function () {
    setTimeout(function() {
      calculateThumbWidth();
      scrollGalleryTo(0);
  
      const $firstVisible = $('.product_media:visible').first();
      const newSrc = $firstVisible.data('img-url');
  
      if (newSrc) {
        const img = new Image();
        img.onload = function () {
          $('.product_featured_media').attr('src', newSrc);
          $('.atc_fixed_content img').attr('src', $firstVisible.data('img-url-thumb'));
        };
        img.src = newSrc;
      }
    }, 50);
  });

  //Handle Fixed Gallery
function checkProductUpperHeight() {
  var $upperProduct = $('.product_upper .product_upper_right');
  var $innerGallery = $('.desktop_new_gallery');

  var upperProductHeight = $upperProduct.outerHeight();
  var galleryHeight = $innerGallery.outerHeight();

  var shouldFix = upperProductHeight >= galleryHeight;

  $innerGallery.toggleClass('fixed_gallery', shouldFix);

  if (!shouldFix) {
    $innerGallery.removeAttr('style');
  }

  if (shouldFix) {
    $upperProduct.css('position', 'relative');

    $(window).off('scroll.fixedGallery').on('scroll.fixedGallery', function() {
      var scrollTop = $(window).scrollTop();
      var headerOffset = 142.19;

      var upperOffsetTop = $upperProduct.offset().top;
      var maxTop = upperProductHeight - galleryHeight;
      var galleryTop = scrollTop + headerOffset;

      if (galleryTop >= upperOffsetTop + maxTop) {
        var currentWidth = $innerGallery.outerWidth();
        $innerGallery.css({
          position: 'absolute',
          top: maxTop + 'px',
          bottom: 'auto',
          width: currentWidth + 'px'
        });
      } else {
        $innerGallery.css({
          position: 'fixed',
          top: headerOffset + 'px',
          bottom: 'auto'
        });
      }
    });

    $(window).trigger('scroll.fixedGallery');
  } else {
    $(window).off('scroll.fixedGallery');
    $innerGallery.css({ position: '', top: '', bottom: '' });
  }
}


  checkProductUpperHeight();

function lockInitialGalleryWidth() {
  const $innerGallery = $('.desktop_new_gallery');
  const $parent = $innerGallery.parent();
  const lockedWidth = $parent.width();
  $innerGallery.css('width', lockedWidth + 'px');
  $innerGallery.data('initial-width-locked', true);
}

lockInitialGalleryWidth();

  
  // Add observer to detect dynamic content changes inside upper product
  const observerTarget = document.querySelector('.product_upper .product_upper_right');
  
  if (observerTarget) {
    const observer = new MutationObserver(() => {
      checkProductUpperHeight();
    });
  
    observer.observe(observerTarget, {
      childList: true,
      subtree: true,
      attributes: true
    });
  }

  
$(window).on('resize', function() {
  checkProductUpperHeight();

  const $innerGallery = $('.desktop_new_gallery');

  // Always update width on resize — but only if gallery is fixed/absolute
  if ($innerGallery.hasClass('fixed_gallery') || $innerGallery.css('position') === 'absolute') {
    const newWidth = $innerGallery.parent().width();
    $innerGallery.css('width', newWidth + 'px');
  } else {
    // If not fixed, reset to CSS default
    $innerGallery.css('width', '');
  }
});


  // Catch early scroll before layout finishes
  $(window).on('scroll.earlyCheck', function() {
    checkProductUpperHeight();
    $(window).off('scroll.earlyCheck');
  });

  /*

const variantIdFromURL = new URLSearchParams(window.location.search).get('variant');
const fallbackVariantId = parseInt($("#preSelectedVariantId").val());

if (!variantIdFromURL && fallbackVariantId) {
  const productData = JSON.parse(document.getElementById('ProductFormData').textContent);
  const fallbackVariant = productData.variants.find(v => v.id === fallbackVariantId);

  if (fallbackVariant && fallbackVariant.options.length > 0) {
    const swatchValue = fallbackVariant.options[0]; // adjust index if needed
    $(".pass_title").show();
    $(".pass_title:not([data-title*='" + swatchValue + "'], [data-title*='All'])")
      .hide()
      .removeClass("product_media_added");
  }
}

  */
  
});



